import React from 'react';

import {Icon, Icons} from '@pb/kit-component-icon';

import {noResultPage, noResultPageDescription} from './no-result-page.module.styl';

type Props = {
    title: string,
    description: string,
    margin?: number,
};

export const NoResultPage: React.FC<Props> = ({title, description, margin = 250}) => (
    <div className={noResultPage} style={{margin: `${margin}px auto`}}>
        <span>
            <Icon type={Icons.INFO}/> <b>{title}</b>
        </span>
        <div className={noResultPageDescription}>
            {description}
        </div>
    </div>
);
